define(['text!./templates/yes-no.html'],
    (templateStr)=> {
        return [()=> {
            return {
                restrict: 'AE',
                template: templateStr,
                scope: {
                    model: '='
                }
            };
        }];
    }
);



// WEBPACK FOOTER //
// ../common/js/src/edge/platform/widgets/inputs/YesNo.js